import type { RootState } from 'models';

export const selectInitial = (state: RootState) => state.initial;
export const selectInitialLoading = ({ initial }: RootState) => initial.loading;
